var map = {
	"./202409/4399.png": "1de3",
	"./202409/android.png": "6f7b",
	"./202409/appstore.png": "305c",
	"./202409/huawei-harmonyos.png": "8e4e",
	"./202409/logo.png": "80e3",
	"./20240923/android.png": "51e7f",
	"./20240923/appstore.png": "eeb0",
	"./20240923/huawei-harmonyos.png": "22c2",
	"./20240923/tips.png": "30d0",
	"./202510/bg.png": "d44d",
	"./202510/censor/en.png": "03ca",
	"./202510/censor/en1.png": "785e",
	"./202510/censor/logo.png": "d93a",
	"./202510/censor/zh.png": "f317",
	"./202510/icons/en/bluesky.png": "e8f2",
	"./202510/icons/en/instagram.png": "24f6",
	"./202510/icons/en/x.png": "7c8b",
	"./202510/icons/en/youtube.png": "8d93",
	"./202510/icons/ja/bluesky.png": "74ce",
	"./202510/icons/ja/instagram.png": "6135",
	"./202510/icons/ja/x.png": "a7c0",
	"./202510/icons/ja/youtube.png": "16c7",
	"./202510/icons/zh/bilibili.png": "7352",
	"./202510/icons/zh/qq.png": "cf1d",
	"./202510/icons/zh/taobao.png": "f214",
	"./202510/icons/zh/xiaoheihe.png": "adf3",
	"./202510/role/a/a-back.png": "84d2",
	"./202510/role/a/a-bottom.png": "4340",
	"./202510/role/bl/bl-back.png": "d052",
	"./202510/role/bl/bl-bottom.png": "a895",
	"./202510/role/es/es-back.png": "eb06",
	"./202510/role/es/es-bottom.png": "b76b",
	"./202510/role/hb/hb-back.png": "b397",
	"./202510/role/hb/hb-bottom.png": "a82e",
	"./202510/role/hk/hk-back.png": "42a2",
	"./202510/role/hk/hk-bottom.png": "700d",
	"./202510/role/hzm/hzm-back.png": "c7b7",
	"./202510/role/hzm/hzm-bottom.png": "7965",
	"./202510/role/jn/jn-back.png": "211d",
	"./202510/role/jn/jn-bottom.png": "b124",
	"./202510/role/kk/kk-back.png": "c7a7",
	"./202510/role/kk/kk-bottom.png": "50a6",
	"./202510/role/ma/ma-back.png": "ebb0",
	"./202510/role/ma/ma-bottom.png": "3419",
	"./202510/role/nol/nol-back.png": "e8da",
	"./202510/role/nol/nol-bottom.png": "c202",
	"./202510/role/nt/nt-back.png": "071e",
	"./202510/role/nt/nt-bottom.png": "3ed8",
	"./202510/role/rc/rc-back.png": "c369",
	"./202510/role/rc/rc-bottom.png": "ccd3",
	"./202510/role/rg/rg-back.png": "6843",
	"./202510/role/rg/rg-bottom.png": "7bc7",
	"./202510/role/tk/tk-back.png": "8b43",
	"./202510/role/tk/tk-bottom.png": "84a0",
	"./202510/shop/en/ns.png": "f9e3",
	"./202510/shop/en/ps.png": "017a",
	"./202510/shop/ja/ns.png": "d014",
	"./202510/shop/ja/ps.png": "2ec3",
	"./202510/shop/zh/ns.png": "74e9",
	"./202510/shop/zh/ps.png": "b343",
	"./202510/title-en.png": "5eac",
	"./202510/title-ja.png": "c124",
	"./202510/title-zh.png": "a5dd",
	"./202510/title2-en.png": "7d67",
	"./202510/title2-ja.png": "a58b",
	"./202510/title2-zh.png": "cede",
	"./202602/announcement/bg.png": "890f",
	"./202602/announcement/btn/cn.png": "227d",
	"./202602/announcement/btn/en.png": "71e4",
	"./202602/announcement/btn/jp.png": "827c",
	"./202602/announcement/cn.png": "070b",
	"./202602/announcement/en.png": "9183",
	"./202602/announcement/jp.png": "47a3",
	"./202602/bg.png": "160b",
	"./202602/shop/xbox.png": "b0ca",
	"./202602/title/en/main.png": "ecb0",
	"./202602/title/en/sub.png": "621b",
	"./202602/title/ja/main.png": "4dbf",
	"./202602/title/ja/sub.png": "d8fa",
	"./202602/title/zh/main.png": "8f2d",
	"./202602/title/zh/sub.png": "ac10",
	"./202603/nav-anno/arrow.png": "d095",
	"./202603/nav-anno/bg.png": "7dba",
	"./202603/nav-anno/icon.png": "fe1c",
	"./202603/nav-anno/icon2.png": "d105",
	"./202603/top-icons/zh/mobile.png": "b4b6",
	"./202603/top-icons/zh/ns.png": "84c5",
	"./202603/top-icons/zh/ps.png": "a507",
	"./202603/top-icons/zh/xbox.png": "e51d",
	"./PS.png": "c310",
	"./QQ.png": "480a",
	"./a-active.png": "fb23",
	"./a-back.png": "45fd",
	"./a.png": "67f6",
	"./bao.png": "2ddd",
	"./bilibili-top.png": "0f12",
	"./bilibili.png": "153a",
	"./bl-active.png": "d8d3",
	"./bl-back.png": "6cd2",
	"./bl.png": "d18f",
	"./close.png": "d991",
	"./copyright-back.png": "1b59",
	"./copyright.png": "45c3",
	"./es-active.png": "9cf9",
	"./es-back.png": "5626",
	"./es.png": "8177",
	"./fbbz-top.png": "14c1",
	"./haoyou-new.png": "cbe5",
	"./hb-active.png": "106a",
	"./hb-back.png": "2b6c",
	"./hb.png": "44c1",
	"./hk-active.png": "d089",
	"./hk-back.png": "c70b",
	"./hk.png": "a902",
	"./hzm-active.png": "af8f",
	"./hzm-back.png": "4e72",
	"./hzm.png": "f176",
	"./icey-active.png": "0030",
	"./icey-back.png": "8661",
	"./icey.png": "d46f",
	"./jn-active.png": "5b80",
	"./jn-back.png": "3e57",
	"./jn.png": "f192",
	"./kk-active.png": "809a",
	"./kk-back.png": "6531",
	"./kk.png": "4fe6",
	"./li-back.png": "acb4",
	"./ma-active.png": "83f5",
	"./ma-back.png": "2651",
	"./ma.png": "72db",
	"./more.png": "6664",
	"./nav-back.png": "a383",
	"./news-back.png": "acaf",
	"./news-content-back.png": "a60b",
	"./news-left.png": "7d3e",
	"./news-playholder.png": "00ea",
	"./news-right.png": "4cbf",
	"./news-title-en.png": "ac7d",
	"./news-title-ja.png": "7503",
	"./news-title-zh.png": "e048",
	"./nol-active.png": "4759",
	"./nol-back.png": "4cde",
	"./nol.png": "3a68",
	"./notice.png": "5114",
	"./nt-active.png": "b6aa",
	"./nt-back.png": "7f5d",
	"./nt-bottom.png": "1840",
	"./nt.png": "c127",
	"./play.png": "c4bf",
	"./rc-active.png": "7c4f",
	"./rc-back.png": "83a1",
	"./rc.png": "9c7b",
	"./rg-active.png": "51e7",
	"./rg-back.png": "4547",
	"./rg.png": "e9ad",
	"./role-back.png": "282e",
	"./role-head-back-1.png": "8d51",
	"./role-head-back.png": "be40",
	"./role-title-en.png": "c992",
	"./role-title-ja.png": "2f20",
	"./role-title-zh.png": "27fd",
	"./role-video.png": "403b",
	"./steam-en.png": "5c1b",
	"./steam-ja.png": "1cce",
	"./steam-zh.png": "3a4a",
	"./switch.png": "a698",
	"./taptap-top.png": "4109",
	"./taptap.png": "16fe",
	"./title-de1.png": "4523",
	"./title-de2.png": "1563",
	"./title-en.png": "fdb8",
	"./title-ja.png": "0bd5",
	"./title-zh.png": "338b",
	"./title2-en.png": "d558",
	"./title2-ja.png": "17b1",
	"./title2-zh.png": "ade8",
	"./tk-active.png": "6e5a",
	"./tk-back.png": "fd29",
	"./tk.png": "013f",
	"./top-back.png": "7934",
	"./top-cover.png": "f488",
	"./video-back.png": "72e6",
	"./video-left.png": "23a9",
	"./video-right.png": "0b8a",
	"./video-title-en.png": "d824",
	"./video-title-ja.png": "37d3",
	"./video-title-zh.png": "0e1a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";